// Color y etiqueta del badge de "tipo de turno" de un turno de recepción.
//
// La fuente de verdad es la tabla `tipo_turno` (Datos Maestros), que trae los 21 tipos reales del
// estudio con su color y su etiqueta. Se registra una vez al iniciar sesión (ver MainLayout) y
// queda cacheada acá, para que estas funciones —que se llaman desde el render de cada tarjeta—
// no necesiten ser asincrónicas ni recibir el catálogo por props en toda la app.
//
// Los mapas de abajo quedan como respaldo: cubren los tipos históricos y evitan que un turno
// salga gris si el catálogo todavía no cargó o la API no responde.

/** Catálogo cargado desde la API, indexado por código. Vacío hasta que MainLayout lo registra. */
let CATALOGO = new Map();

/** La llama MainLayout al iniciar sesión. Idempotente: registrar de nuevo simplemente refresca. */
export function registrarCatalogoTipos(lista) {
    CATALOGO = new Map((lista || []).map((t) => [String(t.codigo).toUpperCase(), t]));
}

function delCatalogo(tipoTramite) {
    return CATALOGO.get(String(tipoTramite || '').trim().toUpperCase());
}

export const COLOR_TRAMITE = {
    RTI: '#dc2626',
    ART: '#f59e0b',
    JUBILACION: '#2563eb',
    PENSION: '#7c3aed',
    REAJUSTE: '#0891b2',
    GENERAL: '#059669',
    ANSES: '#8b5cf6',
    TRIBUNALES: '#ec4899',
    PUAM: '#0d9488',
    PLAN_PAGO: '#f97316',
    GANANCIAS: '#16a34a',
    MINUSVALIA: '#4f46e5',
    DECLARATORIA_HEREDEROS: '#9f1239',
    // Amparo por mora ante ANSES: el color que ya tiene tipo_turno.AMPARO desde V175.
    AMPARO: '#be123c',
};

export const BG_TRAMITE = {
    RTI: '#fee2e2',
    ART: '#fef3c7',
    JUBILACION: '#dbeafe',
    PENSION: '#ede9fe',
    REAJUSTE: '#cffafe',
    GENERAL: '#d1fae5',
    ANSES: '#ede9fe',
    TRIBUNALES: '#fce7f3',
    PUAM: '#ccfbf1',
    PLAN_PAGO: '#ffedd5',
    GANANCIAS: '#dcfce7',
    MINUSVALIA: '#e0e7ff',
    DECLARATORIA_HEREDEROS: '#ffe4e6',
    AMPARO: '#ffe4e6',
};

export function colorTramite(tipoTramite) {
    const delCat = delCatalogo(tipoTramite);
    if (delCat?.color) return delCat.color;
    return COLOR_TRAMITE[String(tipoTramite || '').trim().toUpperCase()] || '#64748b';
}

export function bgTramite(tipoTramite) {
    const delCat = delCatalogo(tipoTramite);
    if (delCat?.colorFondo) return delCat.colorFondo;
    return BG_TRAMITE[String(tipoTramite || '').trim().toUpperCase()] || '#f1f5f9';
}

export function formatearTipoTramite(tipoTramite) {
    if (!tipoTramite) return 'General';
    // La etiqueta del catálogo es la que escribió el estudio ("Junta médica", con acento y
    // minúscula); el formateo automático de abajo daría "Junta Medica".
    const delCat = delCatalogo(tipoTramite);
    if (delCat?.etiqueta) return delCat.etiqueta;
    return String(tipoTramite)
        .toLowerCase()
        .split('_')
        .map((parte) => parte.charAt(0).toUpperCase() + parte.slice(1))
        .join(' ');
}
